import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Field from "../../Components/Field";
import Spinner from "../../../../../Components/common/Spinner/Spinner";
import Warning from "../../../../../Components/common/Warning/Warning";

import TrashBucketIcon from "../../../../../Components/Icon-SVG/TrashBucketIcon";

import {
  RequestCoreServers,
  RequestUpdateCoreServers,
} from "../../../../../store/actions/settingsActions";
import { addNotification } from "../../../../../store/actions/notifierActions";

import "./styles.scss";

function isValidIPv4(ip) {
  try {
    const url = new URL(`http://${ip}`);
    return (
      url.hostname === ip &&
      ip.split(".").every((octet) => {
        const n = Number(octet);
        return n >= 0 && n <= 255;
      })
    );
  } catch {
    return false;
  }
}

const CoreServers = () => {
  const dispatch = useDispatch();

  const coreMap = useSelector((state) => state.settings.coreMap);
  const coreServers = useSelector((state) => state.settings.coreServers);
  const loading = useSelector((state) => state.settings.coreServersLoading);

  const [serverIP, setServerIP] = useState("");
  const [serverListUI, setServerListUI] = useState([]);
  // The core server the delete button was pressed for, kept until the
  // confirmation is answered. Null means the popup is closed.
  const [serverToRemove, setServerToRemove] = useState(null);

  useEffect(() => {
    dispatch(RequestCoreServers());
  }, [dispatch]);

  useEffect(() => {
    setServerListUI(coreServers);
  }, [coreServers]);

  const addServerToListHandler = () => {
    const trimmedIP = serverIP.trim();
    if (!isValidIPv4(trimmedIP)) {
      dispatch(
        addNotification({
          message: "IP is not valid",
          options: { variant: "error" },
          time: 3000,
        }),
      );
    } else if (serverListUI.some((listItem) => listItem === trimmedIP)) {
      dispatch(
        addNotification({
          message: "IP already exists",
          options: { variant: "error" },
          time: 3000,
        }),
      );
    } else {
      setServerListUI((prevState) => [...prevState, trimmedIP]);
      setServerIP("");
    }
  };

  const warningClickOKHandler = () => {
    setServerListUI((prevState) => prevState.filter((el) => el !== serverToRemove));
    setServerToRemove(null);
  };

  const updateCoreServers = () => {
    if (loading) return;
    dispatch(RequestUpdateCoreServers(serverListUI));
  };

  const checkUpdateButtonDisabled = () => {
    if (serverListUI.length === 0) {
      return true;
    }
    if (
      coreServers.every((cs) => serverListUI.includes(cs)) &&
      coreServers.length === serverListUI.length
    ) {
      return true;
    }
    return false;
  };

  return (
    <div className="core-servers">
      <h1 className="core-servers__header">Core Servers</h1>
      <div className="core-servers__body">
        <div className="core-servers__body__header">
          <h3>Core servers</h3>
          <p>NOTE: You can edit the list of cores.</p>
        </div>
        <div className="core-servers__body__content">
          <div className="core-servers__field">
            <Field
              label="Core Server IP"
              width="250px"
              value={serverIP}
              onChange={(e) => setServerIP(e.target.value)}
              placeholder="Enter core server ip (e.g., 192.168.x.x)"
              name="coreServerIP"
            />
            <button type="button" onClick={addServerToListHandler}>
              +
            </button>
          </div>
          {loading ? (
            <div className="core-servers__loading">
              <Spinner width={20} height={20} />
            </div>
          ) : serverListUI.length > 0 ? (
            <ul className="core-servers__list">
              {serverListUI?.map((item, index) => (
                <li key={index}>
                  {item} {coreMap[item] ? `(${coreMap[item]})` : coreMap[item]}
                  <button
                    type="button"
                    style={{ display: "flex" }}
                    onClick={() => setServerToRemove(item)}>
                    <TrashBucketIcon width="16" height="16" />
                    <p style={{ marginLeft: "5px" }}>Delete</p>
                  </button>
                </li>
              ))}
            </ul>
          ) : null}
          <button
            className="primary-button"
            onClick={updateCoreServers}
            disabled={checkUpdateButtonDisabled()}>
            Update
          </button>
        </div>
      </div>
      <Warning
        onClickOk={warningClickOKHandler}
        show={serverToRemove !== null}
        setShow={() => setServerToRemove(null)}
        text={`Are you sure you want to delete the core server ${serverToRemove} ?`}
        article="Confirm delete"
        cancelDisable={false}
      />
    </div>
  );
};

export default CoreServers;
